import { Redirect } from 'src/utils/hooks/useRedirect';
export default Redirect;
